import type * as core from '../../../../../../../core'

export const query: core.mosaic.Widget.Query = {
  selection: {
    '{}': {
      name: {
        if: [
          [
            {
              '!=': [
                {
                  '@': 'editingExternalInstitution',
                },
                null,
              ],
            },
            'Edit External Institution',
          ],
          'Create New External Institution',
        ],
      },
      type: 'details',
      content: {
        '{}': {
          fields: {
            '[]': [
              {
                '{}': {
                  id: 'code',
                  value: {
                    '@>': [
                      {
                        '@': 'editingExternalInstitution',
                      },
                      'code',
                    ],
                  },
                  meta: {
                    '{}': {
                      dmsAttr: {
                        '{}': {
                          attributeId:
                            'attr:ent#!ext_institutions#!institution:!code',
                        },
                      },
                    },
                  },
                },
              },
              {
                '{}': {
                  id: 'name',
                  value: {
                    '@>': [
                      {
                        '@': 'editingExternalInstitution',
                      },
                      'name',
                    ],
                  },
                  meta: {
                    '{}': {
                      dmsAttr: {
                        '{}': {
                          attributeId:
                            'attr:ent#!ext_institutions#!institution:!name',
                        },
                      },
                    },
                  },
                },
              },
              {
                '{}': {
                  id: 'address',
                  value: {
                    '@>': [
                      {
                        '@': 'editingExternalInstitution',
                      },
                      'address',
                    ],
                  },
                  meta: {
                    '{}': {
                      dmsAttr: {
                        '{}': {
                          attributeId:
                            'attr:ent#!ext_institutions#!institution:!address',
                        },
                      },
                    },
                  },
                },
              },
              {
                '{}': {
                  id: 'ein',
                  value: {
                    '@>': [
                      {
                        '@': 'editingExternalInstitution',
                      },
                      'ein',
                    ],
                  },
                  meta: {
                    '{}': {
                      dmsAttr: {
                        '{}': {
                          attributeId:
                            'attr:ent#!ext_institutions#!institution:!ein',
                        },
                      },
                    },
                  },
                },
              },
              {
                '{}': {
                  id: 'uei',
                  value: {
                    '@>': [
                      {
                        '@': 'editingExternalInstitution',
                      },
                      'uei',
                    ],
                  },
                  meta: {
                    '{}': {
                      dmsAttr: {
                        '{}': {
                          attributeId:
                            'attr:ent#!ext_institutions#!institution:!uei',
                        },
                      },
                    },
                  },
                },
              },
              {
                '{}': {
                  id: 'sam_name',
                  value: {
                    '@>': [
                      {
                        '@': 'editingExternalInstitution',
                      },
                      'sam_name',
                    ],
                  },
                  meta: {
                    '{}': {
                      dmsAttr: {
                        '{}': {
                          attributeId:
                            'attr:ent#!ext_institutions#!institution:!sam_name',
                        },
                      },
                    },
                  },
                },
              },
              {
                '{}': {
                  id: 'type',
                  value: {
                    '@>': [
                      {
                        '@': 'editingExternalInstitution',
                      },
                      'type',
                    ],
                  },
                  meta: {
                    '{}': {
                      dmsAttr: {
                        '{}': {
                          attributeId:
                            'attr:ent#!ext_institutions#!institution:!type',
                        },
                      },
                    },
                  },
                },
              },
            ],
          },
          onSave: {
            '{}': {
              action: {
                '{}': {
                  alias: 'sr.actions.save-external-institution',
                },
              },
              variables: {
                '{}': {
                  exInstId: {
                    '@$': 'externalInstitutionId',
                  },
                  exInstCode: '${field:code}',
                  exInstName: '${field:name}',
                  exInstEin: '${field:ein}',
                  exInstUei: '${field:uei}',
                  exInstSamName: '${field:sam_name}',
                  exInstType: '${field:type}',
                },
              },
            },
          },
        },
      },
    },
  },
  subqueries: {
    editingExternalInstitution: {
      selection: {
        '{}': {
          code: {
            '@.': '!code',
          },
          name: {
            '@.': '!name',
          },
          ein: {
            '@.': '!ein',
          },
          uei: {
            '@.': '!uei',
          },
          sam_name: {
            '@.': '!sam_name',
          },
          type: {
            '@.': '!type',
          },
        },
      },
      target: 'ent:!ext_institutions:!institution',
      quantity: 1,
      filter: {
        '=': [
          {
            '@.': '!id',
          },
          {
            '@$': 'externalInstitutionId',
          },
        ],
      },
    },
  },
}
